/* 🤖 this file was generated by svg-to-ts */
export const emperorIconUser: {
  name: 'user';
  data: string;
} = {
  name: 'user',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M12.002 12.006c-2.21 0-4-1.8-4-4 0-2.205 1.79-4 4-4 2.2 0 4 1.795 4 4 -.001 2.2-1.8 4-4 4Zm0-6c-1.11 0-2 .89-2 2 0 1.1.89 2 2 2 1.1 0 2-.9 2-2 0-1.104-.9-2-2-2Z"/><path d="M20.002 20.006H4v-1c0-3.54 3.29-6 8-6s8 2.46 8 6v1Zm-13.841-2h11.68c-.6-1.81-2.833-3-5.85-3 -3.01 0-5.244 1.19-5.85 3Z"/></g></svg>`,
};
